import { render, staticRenderFns } from "./SuccessStatus.vue?vue&type=template&id=3305be34&scoped=true&"
import script from "./SuccessStatus.vue?vue&type=script&lang=ts&"
export * from "./SuccessStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessStatus.vue?vue&type=style&index=0&id=3305be34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3305be34",
  null
  
)

export default component.exports